import BaseService from '../BaseService';
import { type GenericPage, type PagedParams } from '@/types';

/**
 * Generic Service for making http requests
 * T - Entity to be updated
 * U - Update Request Object
 * P - Paged request defaults to generic paged params but can be extended by passing in a generic
 */
export class GenericService<T, U, P = PagedParams> extends BaseService {
  private baseUrl;
  private controller;
  constructor(baseUrl: string, controller: string) {
    super();
    this.baseUrl = baseUrl;
    this.controller = controller;
  }

  getById = async (id: string): Promise<T> => {
    return await this.get<T>({ baseUrl: this.baseUrl, path: `${this.controller}/${id}` });
  };

  getItems = async (request?: P): Promise<GenericPage<T>> => {
    return await this.get<GenericPage<T>>({
      baseUrl: this.baseUrl,
      path: `${this.controller}`,
      params: { ...request },
    });
  };

  addItem = async (item: U): Promise<T> => {
    return await this.post({
      baseUrl: this.baseUrl,
      path: `${this.controller}`,
      body: item,
    });
  };

  updateItem = async (item: U): Promise<T> => {
    return await this.put({
      baseUrl: this.baseUrl,
      path: `${this.controller}`,
      body: item,
    });
  };
}
